import React, { useRef, useState } from "react";
import { api, API_BASE } from "../lib/api";
import { toast } from "sonner";
import { Upload, Loader2, X } from "lucide-react";

export default function ImageUpload({ value, onChange, testId = "image-upload" }) {
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  const upload = async (file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { toast.error("Max 5 MB"); return; }
    if (!/^image\/(jpeg|jpg|png|webp|gif)$/.test(file.type)) { toast.error("Only JPG/PNG/WEBP/GIF"); return; }
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch { toast.error("Upload failed"); }
    finally { setLoading(false); if (inputRef.current) inputRef.current.value = ""; }
  };

  return (
    <div className="mt-1 space-y-2" data-testid={testId}>
      <div className="flex items-center gap-3">
        {value && (
          <div className="relative">
            <img src={value} alt="" className="w-20 h-20 object-cover rounded-xl border border-slate-200" />
            <button type="button" onClick={() => onChange("")} className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-white border border-slate-200 shadow flex items-center justify-center hover:bg-slate-50" data-testid={`${testId}-clear`} aria-label="Remove image"><X className="w-3 h-3" /></button>
          </div>
        )}
        <label className="flex-1 cursor-pointer border-2 border-dashed border-slate-200 rounded-xl p-4 text-center hover:border-[#FF7D00] hover:bg-orange-50/40 transition text-sm text-slate-500">
          <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" onChange={(e) => upload(e.target.files?.[0])} className="hidden" data-testid={`${testId}-input`} />
          {loading ? <span className="flex items-center justify-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Uploading…</span>
                   : <span className="flex items-center justify-center gap-2"><Upload className="w-4 h-4" /> {value ? "Replace image" : "Click to upload image"}</span>}
          <div className="text-[11px] text-slate-400 mt-1">JPG, PNG, WEBP · max 5 MB</div>
        </label>
      </div>
      <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="…or paste an image URL" className="w-full px-4 py-2 rounded-xl border border-slate-200 text-xs focus:outline-none focus:border-[#006CE4] transition" data-testid={`${testId}-url`} />
    </div>
  );
}
